import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {URLSearchParams} from '@angular/http';
import {EnvironmentService} from './environment.service';

import {environment} from '../../../environments/environment';

@Injectable()
export class ApiService {
    protected baseUrl = '';

    protected httpOptions = {headers: new HttpHeaders()}

    constructor(private http: HttpClient, private env: EnvironmentService) {
        this.baseUrl = env.getApiUrl();
    }


    createUrl(url: string) {
        if (url.indexOf('http://') >= 0 || url.indexOf('https://') >= 0) {
            return url;
        } else {
            return this.baseUrl.concat(url);
        }
    }

    createUrlWithParams(url: string, params?: object) {
        const queryParams = new URLSearchParams();
        for (const key in params) {
            if (params.hasOwnProperty(key)) {
                queryParams.set(key, params[key])
            }
        }

        return (params) ? this.createUrl(url).concat('?' + queryParams.toString()) : this.createUrl(url);
    }

    createOptions(headers?: Object): Object {

        let customHeader = this.httpOptions.headers;
        if (headers) {
            for (const key in headers) {
                if (headers.hasOwnProperty(key)) {
                    customHeader = customHeader.set(key, headers[key]);
                }
            }
        }

        return {headers: customHeader};
    }

    setToken(token: string) {
        this.httpOptions = {
            headers: new HttpHeaders(
                {
                    'X-API-TOKEN': token
                }
            )
        }
    }

    getHttp() {
        return this.http;
    }

    post(url: string, data: Object, header?: Object) {
        return this.http.post(this.createUrl(url), data, this.createOptions(header));
    }

    get(url: string, params?: Object, header?: Object) {
        return this.http.get(this.createUrlWithParams(url, params), this.createOptions(header));
    }
}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/core/service/api.service.ts